const API_URL = import.meta.env.VITE_RPS_API + '/games?chain_id=';

export const fetchGamesApi = async (chainId: number) => {
  const response = await fetch(`${API_URL}${chainId}`, {
    method: 'GET',
  });
  const data = await response.json();

  return data.rows;
};
